import { ITokenDados, ITokenPermanente } from './../utils/interfaces/token.interface';
import { Injectable } from '@angular/core';
import { SfAuthenticatorService, SfConnectorService, SfWorkContextService } from '@safra-frontend/core';
import { ConsentResourceService } from './consent-resource.service';
import { AlertaService } from '@shared/modules/alerta/alerta.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Consumidor } from '@shared/utils/interfaces/receptora.interface';

@Injectable({
  providedIn: 'root',
})
export class TokenService extends ConsentResourceService {
  constructor(
    protected sfAuth: SfAuthenticatorService,
    sfConnector: SfConnectorService,
    sfWorkContext: SfWorkContextService,
    alertaService: AlertaService
  ) {
    super(sfConnector, sfWorkContext, alertaService);
  }

  getTokenIdPermanente(tokenIdTemporario: string): Observable<{ data: ITokenPermanente }> {
    // return this.sfConnector
    //   .execute<{ data: ITokenPermanente }>('GET', `/token/refresh-id/${tokenIdTemporario}`)
    //   .pipe(catchError((error: HttpErrorResponse) => this.alertaService.handleHttpErrorToken(error)));

    return this.sfAuth
      .authenticate({
        idEstrategia: 'token',
        credenciais: {
          id_token: tokenIdTemporario,
        },
      })
      .pipe(
        map((res) => ({
          data: {
            tokenId: tokenIdTemporario,
          },
        })),
        catchError((error: HttpErrorResponse) => this.alertaService.handleHttpErrorToken(error))
      );
  }

  getTokenDados(token: string): Observable<ITokenDados> {
    return this.sfConnector
      .execute<ITokenDados>('GET', '/token/get-token-home', { params: { tokenId: token } })
      .pipe(catchError((error: HttpErrorResponse) => this.alertaService.handleHttpError(error)));
  }
}
